import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
export default function TelegramAuth() {
  const telegramWrapperRef = useRef(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get('type');
    const id = searchParams.get('id');

    if (type === 'app' && id) {
      const payload = {
        id: searchParams.get('id'),
        first_name: searchParams.get('first_name'),
        last_name: searchParams.get('last_name'),
        username: searchParams.get('username'),
        photo_url: searchParams.get('photo_url'),
        auth_date: searchParams.get('auth_date'),
        hash: searchParams.get('hash'),
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    } else {
      if (window.Telegram && process.env.REACT_APP_TELEGRAM_BOT_ID) {
        if (type === 'app') {
          const scriptElement = document.createElement('script');
          scriptElement.src = 'https://telegram.org/js/telegram-widget.js?22';
          scriptElement.setAttribute('data-telegram-login', 'CypherHQBot');
          scriptElement.setAttribute('data-size', 'large');
          scriptElement.setAttribute(
            'data-auth-url',
            'https://cypherhq.io/telegram/auth?type=app'
          );
          scriptElement.setAttribute('data-request-access', 'write');
          // scriptElement.setAttribute('data-onauth', telegramAuth);
          scriptElement.async = true;

          telegramWrapperRef.current.appendChild(scriptElement);
        } else {
          window.Telegram.Login.auth(
            {
              bot_id: process.env.REACT_APP_TELEGRAM_BOT_ID,
              request_access: true,
            },
            (data: any) => {
              if (type === 'dApp' || type === 'business') {
                let separator = '?';
                let redirectUrl =
                  type === 'dApp'
                    ? process.env.REACT_APP_DAPP_TG_REDIRECT_URL
                    : process.env.REACT_APP_BUSINESS_TG_REDIRECT_URL;
                for (const key in data) {
                  if (data.hasOwnProperty(key)) {
                    // Encode the key and value, and push them as a key-value pair to the queryParams array
                    const encodedKey = encodeURIComponent(key);
                    const encodedValue = encodeURIComponent(data[key]);
                    redirectUrl += `${separator}${encodedKey}=${encodedValue}`;
                    separator = '&';
                  }
                }
                window.location.href = redirectUrl;
              }
            }
          );
        }
      }
    }
  }, [window.Telegram]);
  return (
    <div className='h-screen flex justify-center items-center'>
      <div ref={telegramWrapperRef}></div>
    </div>
  );
}
